import {IconButton} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, {useEffect, useState} from 'react';
import {firestore} from '../../Firebase';
import Icons from '../../Icons/JavaScript/Icons';

function Services() {
    const [disable, setDisable] = useState(false);
    const [moreLess, setMoreLess] = useState('More');
    const [servicesData, setServicesData] = useState([]);
    
    useEffect(
        () => {
            firestore.collection("Services").onSnapshot(
                (snapShot) => {
                    setServicesData(
                        snapShot.docs.map(
                            (doc) => (
                                {
                                    imageURL: doc.data().imageURL,
                                    name: doc.data().name,
                                    text: doc.data().text
                                }    
                            )
                        )
                    )
                }
            )
        }, []
    )
    
    useEffect(
        () => {
            if (servicesData.length === 0) {
                let servicesSection = document.getElementsByClassName("services")[0];
                servicesSection.style.display = "none";
            }
            else {
                let servicesSection = document.getElementsByClassName("services")[0];
                servicesSection.style.display = "grid";
            }
        }, [servicesData.length]
    )
    
    const expand = () => {
        let iconsDiv = document.getElementsByClassName("servicesIcons")[0];
        let servicesExpandButton = document.getElementsByClassName("services__expand__button")[0];
        let maxHeightValue;
        
        if (window.matchMedia("(max-width: 440px) and (max-height: 900px)").matches) {
            if (iconsDiv.offsetHeight < 165) {
                setDisable(true);
            }
            
            maxHeightValue = "47vw";
        }
        else {
            if (iconsDiv.offsetHeight < 490) {
                setDisable(true);
            }
            
            maxHeightValue = "36vw";
        }
        
        if (iconsDiv.style.maxHeight === maxHeightValue) {
            iconsDiv.style.maxHeight = "100%";
            servicesExpandButton.style.transform = "rotate(180deg)";
            setMoreLess("Less");
        }
        else {
            iconsDiv.style.maxHeight = maxHeightValue;
            servicesExpandButton.style.transform = "rotate(0deg)";
            setMoreLess("More");
        }   
    }
    
    return (
        <section className="services">
            <Icons type={"servicesIcons"} data={servicesData} />
            <IconButton className="services__expand" onClick={expand} disabled={disable} data-aos="fade-down" data-aos-delay="400">
                <span className="services__expand__text">Show {moreLess}</span>
                <ExpandMoreIcon className="services__expand__button" />
            </IconButton>
        </section>
    )
}

export default Services
